import { createSlice } from '@reduxjs/toolkit'
import { KubernetesNode, ListResultError } from 'common/api/v1/types'
import type { ApplicationException } from '../../api/ApplicationException'
import { logoutUser } from '../actions/userActions'
import {
  clearKubernetesNode,
  clearKubernetesNodes,
  getKubernetesNode,
  getKubernetesNodes,
  updateKubernetesNode,
} from '../actions/k8sActions'
import { createLoadingReducer } from './shared'

interface State {
  kubernetesNodes: Array<KubernetesNode>
  kubernetesNode: KubernetesNode | undefined
  formErrors?: ApplicationException['errorInfo']['details'] // unused
  loading: boolean
  saving: boolean
  total: number
  errors?: ListResultError[]
}

const initialStateNodes: State = {
  kubernetesNodes: [],
  kubernetesNode: undefined,
  loading: false,
  saving: false,
  total: 0,
}

const { isLoadingAction, loadingReducer } = createLoadingReducer<State>(getKubernetesNodes, getKubernetesNode)

const nodesSlice = createSlice({
  name: 'kubernetesNodes',
  initialState: initialStateNodes,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(
        getKubernetesNodes.fulfilled,
        (state, { payload: { items: kubernetesNodes, total, errors } }): State => ({
          ...state,
          kubernetesNodes: kubernetesNodes,
          total,
          errors,
        }),
      )

      .addCase(
        getKubernetesNode.fulfilled,
        (state, { payload: kubernetesNode }): State => ({
          ...state,
          kubernetesNode,
        }),
      )

      .addCase(
        updateKubernetesNode.fulfilled,
        (state, { payload: kubernetesNode }): State => ({
          ...state,
          kubernetesNode,
          formErrors: undefined,
        }),
      )

      .addCase(clearKubernetesNode, (state): State => ({ ...state, kubernetesNode: undefined, formErrors: undefined }))
      .addCase(clearKubernetesNodes, (state): State => ({ ...state, kubernetesNodes: [], formErrors: undefined }))

      .addCase(logoutUser.fulfilled, (): State => initialStateNodes)

      .addMatcher(isLoadingAction, loadingReducer)
  },
})

export default nodesSlice.reducer
